var installedModules = {};
var moduleToHandlerMapping = {
	3049: {
		getter: () => (__webpack_require__.e(377).then(() => (() => (__webpack_require__(4377))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	435: {
		getter: () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(524)]).then(() => (() => (__webpack_require__(8524))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/core",
	},
	4001: {
		getter: () => (__webpack_require__.e(377).then(() => (() => (__webpack_require__(4377))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	3499: {
		getter: () => (Promise.all([__webpack_require__.e(486), __webpack_require__.e(1)]).then(() => (() => (__webpack_require__(9486))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/dev-tools-utils",
	},
	5587: {
		getter: () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(4420))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	7804: {
		getter: () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(798)]).then(() => (() => (__webpack_require__(3798))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	9442: {
		getter: () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(798)]).then(() => (() => (__webpack_require__(3798))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"1": [
		4001
	],
	"401": [
		3499,
		5587,
		7804,
		9442
	],
	"435": [
		435
	],
	"798": [
		3049
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}